import { useEffect, useState, useRef } from 'react';
import { throttle } from 'lodash';

// TODO позже сделать приоритет(то есть, чтобы работал один из, а не 2 одновременно)

type UseScrollTriggerOptions = {
  /** CSS-селектор или data-атрибут для поиска триггер-элемента */
  triggerSelector?: string;
  /** Позиция срабатывания (в пикселях от верха viewport) */
  triggerPosition?: number;
  /** Только первое срабатывание */
  once?: boolean;
  /** Куда добавлять data-атрибут (по умолчанию documentElement) */
  targetElement?: HTMLElement | null;
  /** Имя data-атрибута для добавления */
  dataAttribute?: string;
  /** Порог для IntersectionObserver (0-1) */
  threshold?: number;
  /** Задержка для throttle (мс) */
  throttleDelay?: number;
};

/**
 * Универсальный хук для отслеживания скролла до определенного элемента
 * @param options Настройки хука
 * @returns Состояние триггера (boolean)
 */
export const useScrollTrigger = (
  options?: UseScrollTriggerOptions
): boolean => {
  const {
    triggerSelector = '[data-section]',
    triggerPosition = 0,
    once = false,
    targetElement = document.documentElement,
    dataAttribute = 'data-scroll-triggered',
    threshold = 0,
    throttleDelay = 100,
  } = options || {};

  const [isTriggered, setIsTriggered] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (once && triggeredRef.current) return;

    const handleScroll = throttle(() => {
      const triggerElement = document.querySelector(triggerSelector);
      if (!triggerElement) return;

      const rect = triggerElement.getBoundingClientRect();
      const isReached = rect.top <= triggerPosition;

      if (isReached !== isTriggered) {
        setIsTriggered(isReached);
        // if (targetElement) {
        //   targetElement.toggleAttribute(dataAttribute, isReached);
        // }
        if (isReached) triggeredRef.current = true;
      }
    }, throttleDelay);

    // const initObserver = () => {
    //   if (observerRef.current) {
    //     observerRef.current.disconnect();
    //   }

    //   observerRef.current = new IntersectionObserver(
    //     (entries) => {
    //       entries.forEach(entry => {
    //         const isReached = entry.boundingClientRect.top <= triggerPosition;
    //         const shouldUpdate = isReached !== isTriggered && (!once || !triggeredRef.current);

    //         if (shouldUpdate) {
    //           setIsTriggered(isReached);
    //         //   if (targetElement) {
    //         //     targetElement.toggleAttribute(dataAttribute, isReached);
    //         //   }
    //           if (isReached) triggeredRef.current = true;
    //         }
    //       });
    //     },
    //     {
    //       threshold,
    //       rootMargin: `${triggerPosition}px 0px 0px 0px`
    //     }
    //   );

    //   const triggers = document.querySelectorAll(triggerSelector);
    //   triggers.forEach(trigger => observerRef.current?.observe(trigger));
    // };

    // Используем оба метода для максимальной надежности
    window.addEventListener('scroll', handleScroll);
    // initObserver();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      // observerRef.current?.disconnect();
    };
  }, [
    isTriggered,
    triggerSelector,
    triggerPosition,
    once,
    targetElement,
    dataAttribute,
    threshold,
    throttleDelay,
  ]);

  return isTriggered;
};
